import React, { useState } from 'react';

// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { SET_CHANGED_ROLE } from 'redux/slices/people';
import { Button } from 'ui/atoms';

import { partnerRoles } from '../../../const';
import commPartnerAdmin from '../../assets/img/comm-partner-admin.png';
import commPartner from '../../assets/img/comm-partner.png';
import techPartnerAdmin from '../../assets/img/tech-partner-admin.png';
import techPartner from '../../assets/img/tech-partner.png';
import { ButtonContainer, RoleIcon } from './style';

const AccountRole = ({ setChangeRole, selectedData, roleError }) => {
  const { t } = useTranslation();
  const [role, setRole] = useState('');

  const handleRoleButton = e => {
    const val = e.target.value;
    setRole(val);
    setChangeRole(val);
  };

  const selectedRole = selectedData[0]?.originalRole;
  return (
    <ButtonContainer>
      {selectedRole !== partnerRoles.COMMERCIAL_PARTNER_SUPER_USER && (
        <Button
          variant="create-account-buttons"
          selected={role === partnerRoles.COMMERCIAL_PARTNER_SUPER_USER}
          value={partnerRoles.COMMERCIAL_PARTNER_SUPER_USER}
          onClick={handleRoleButton}
          error={roleError}
        >
          <RoleIcon icon={commPartnerAdmin} />
          {t('comm_partner_admin')}
        </Button>
      )}
      {selectedRole !== partnerRoles.COMMERCIAL_PARTNER_USER && (
        <Button
          variant="create-account-buttons"
          selected={role === partnerRoles.COMMERCIAL_PARTNER_USER}
          value={partnerRoles.COMMERCIAL_PARTNER_USER}
          onClick={handleRoleButton}
          error={roleError}
        >
          <RoleIcon icon={commPartner} />
          {t('comm_partner')}
        </Button>
      )}
      {selectedRole !== partnerRoles.TECHNICAL_PARTNER_SUPER_USER && (
        <Button
          variant="create-account-buttons"
          selected={role === partnerRoles.TECHNICAL_PARTNER_SUPER_USER}
          value={partnerRoles.TECHNICAL_PARTNER_SUPER_USER}
          onClick={handleRoleButton}
          error={roleError}
        >
          <RoleIcon icon={techPartnerAdmin} />
          {t('tech_partner_admin')}
        </Button>
      )}
      {selectedRole !== partnerRoles.TECHNICAL_PARTNER_USER && (
        <Button
          variant="create-account-buttons"
          selected={role === partnerRoles.TECHNICAL_PARTNER_USER}
          value={partnerRoles.TECHNICAL_PARTNER_USER}
          onClick={handleRoleButton}
          error={roleError}
        >
          <RoleIcon icon={techPartner} />
          {t('tech_partner')}
        </Button>
      )}
    </ButtonContainer>
  );
};

AccountRole.propTypes = {
  setChangeRole: PropTypes.func,
  selectedData: PropTypes.array,
  roleError: PropTypes.bool
};
//SET_CHANGED_ROLE
export default connect(
  () => ({}),
  dispatch => ({
    setChangeRole: payload => dispatch(SET_CHANGED_ROLE(payload))
  })
)(AccountRole);
